/**
 * Path of E11, the Account tab (S8 R23). Home links to it (`homeLinks.account`) and `TABS` lists
 * it; `AppRoutes.test.tsx` keeps the three equal.
 */
export const ACCOUNT_ROUTE = '/account';
